import { useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { useCurrentPage } from '»utils/customHooks';

import BPCBgLoginPage from '../../../assets/img/BPC_bg-login.webp';
import BPCBgLPageSM from '../../../assets/img/BPC_bg-lpage-sm.webp';
import { GradientContainer, TextContainer } from '../AppCard.styles';
import {
  BackgroundMobileImageStyled,
  BoxBackgroundImageStyled,
  CardContainer,
  LandingPageText,
} from './AppCardBPC.styles';

export const AppCardBPC = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();

  const { isNoAuthFormPage, isLoginPage, isOnboardingAdvancedSteps } =
    useCurrentPage(location.pathname);

  if (isDesktop)
    return (
      <BoxBackgroundImageStyled
        isFormPage={isNoAuthFormPage}
        isLoginPage={isLoginPage}
        isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
      >
        <GradientContainer
          isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
        >
          <TextContainer isFormPage={isNoAuthFormPage}>
            <LandingPageText isFormPage={isNoAuthFormPage}>
              <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_BPC" />
            </LandingPageText>
          </TextContainer>
        </GradientContainer>
      </BoxBackgroundImageStyled>
    );

  return (
    <CardContainer isFormPage={isNoAuthFormPage}>
      <LandingPageText isFormPage={isNoAuthFormPage}>
        <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_BPC" />
      </LandingPageText>
      <BackgroundMobileImageStyled
        alt="background-mobile-image"
        component="img"
        src={isLoginPage ? BPCBgLoginPage : BPCBgLPageSM}
        isFormPage={isNoAuthFormPage}
      />
    </CardContainer>
  );
};
